// Écran d'accueil : couvre tout dès la première frame (son style est inline dans index.html,
// il n'attend pas la feuille de style principale), reste au moins `minMs`, puis attend que les
// polices soient prêtes avant de s'effacer en fondu. Résout quand l'écran est retiré.
import { $, hide } from './dom.js';

export const SPLASH_MIN_MS = 2000;
export const SPLASH_FADE_MS = 450;

/**
 * @param {object} [options]
 * @param {number} [options.minMs]        durée minimale d'affichage
 * @param {Promise} [options.ready]       à attendre en plus (ex. document.fonts.ready)
 * @param {(cb: () => void, ms: number) => unknown} [options.wait]  injectable pour les tests
 */
export function dismissSplash({ minMs = SPLASH_MIN_MS, ready = Promise.resolve(), wait = (cb, ms) => setTimeout(cb, ms) } = {}) {
  const splash = $('splashScreen');
  const minimum = new Promise((resolve) => wait(resolve, minMs));
  // Une police qui traîne ne doit jamais bloquer l'entrée dans le jeu : 3 s de patience maximum
  const fonts = Promise.race([ready.catch(() => {}), new Promise((resolve) => wait(resolve, 3000))]);

  return Promise.all([minimum, fonts]).then(() => new Promise((resolve) => {
    splash.classList.add('is-leaving');
    wait(() => { hide(splash); resolve(); }, SPLASH_FADE_MS);
  }));
}
